module.exports = __webpack_public_path__ + "static/media/Roboto-LightItalic.a3ce4440.ttf";